import { createSelector } from 'reselect';
import { Map as iMap } from 'immutable';

const onboardingStatus = (state) => state.get('onboardingStatus', iMap());

export const onboardingStatusSelector = createSelector(
  [onboardingStatus],
  (onboardingStatus) => onboardingStatus,
);
